import React from "react";
import { Section, LinkedInGithub, Bullets, ProjectLink } from "./shared";

const T = ({ children }) => <h2>{children}</h2>;

const Template6 = ({ data }) => (
  <div className="rt rt6">
    {/* LEFT */}
    <div className="rt6-left">
      <h1>{data.fullName}</h1>
      <div className="rt6-contact">
        {data.email && <p>{data.email}</p>}
        {data.phoneNo && <p>{data.phoneNo}</p>}
        {(data.linkedinId || data.githubId) && (
          <p><LinkedInGithub data={data} /></p>
        )}
        {data.location && <p>{data.location}</p>}
      </div>

      <Section
        title={<T>Summary</T>}
        items={[data.summary && <p>{data.summary}</p>]}
      />
      <Section
        title={<T>Education</T>}
        items={data.education.map((e, i) => (
          <div key={i} className="rt-avoid rt6-edu">
            {e.year && <span>{e.year}</span>}
            {e.degree && <span>{e.degree}</span>}
            {e.institute && <span>{e.institute}</span>}
          </div>
        ))}
      />
      <Section
        title={<T>Skills</T>}
        items={[
          data.skills.length > 0 && (
            <ul className="rt6-skills rt-avoid">
              {data.skills.map((s) => (
                <li key={s.key}>{`${s.key}: ${s.value}`}</li>
              ))}
            </ul>
          ),
        ]}
      />
    </div>

    {/* RIGHT */}
    <div className="rt6-right">
      <Section
        title={<T>Experience</T>}
        items={
          data.experiences.length
            ? data.experiences.map((x, i) => (
                <div key={i} className="rt-avoid rt6-job">
                  <h3>{[x.role, x.company].filter(Boolean).join(" | ")}</h3>
                  {x.duration && <span>{x.duration}</span>}
                  {x.description && <p>{x.description}</p>}
                </div>
              ))
            : [<p>Fresher</p>]
        }
      />
      <Section
        title={<T>Projects</T>}
        items={data.projects.map((p, i) => (
          <div key={i} className="rt-avoid rt6-job">
            <h3>{p.projectName}</h3>
            <Bullets points={p.description} />
            <ProjectLink url={p.projectLink} />
          </div>
        ))}
      />
      <Section
        title={<T>Achievements</T>}
        items={[
          data.others.length > 0 && (
            <ul className="rt-avoid">
              {data.others.map((o, i) => (
                <li key={i}>{o}</li>
              ))}
            </ul>
          ),
        ]}
      />
    </div>
  </div>
);

export default Template6;